import EditTemplate from './EditTemplate';

export default EditTemplate;
